export default __webpack_public_path__ + "static/media/clouds.058d1121.png";